import { _isMobile } from "@/pixels/utils/helpers";

describe("_isMobile", () => {
  it("should return true when userAgent is from a mobile device", () => {
    // Mocking the userAgent to simulate a mobile device
    Object.defineProperty(window.navigator, "userAgent", {
      value:
        "Mozilla/5.0 (iPhone; CPU iPhone OS 14_0 like Mac OS X) AppleWebKit/605.1.15 (KHTML, like Gecko) Version/14.0 Mobile/15E148 Safari/604.1",
      configurable: true
    });

    expect(_isMobile()).toBe(true);
  });

  it("should return false when userAgent is from a non-mobile device", () => {
    // Mocking the userAgent to simulate a non-mobile device
    Object.defineProperty(window.navigator, "userAgent", {
      value:
        "Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/94.0.4606.81 Safari/537.36",
      configurable: true
    });

    expect(_isMobile()).toBe(false);
  });
});
